export function extractChain({ chains, id, }) {
    return chains.find((chain) => chain.id === id);
}
//# sourceMappingURL=extractChain.js.map